import Vue from 'vue'
import Vuex from 'vuex'
import storage from '@/utils/storage'
import { asyncRoutes, constantRoutes } from '@/router/modules/allRoutes'
import { beat } from '@/api/heartBeat'
import configStore from './configStore';
import yioksStorage from "@/assets/js/yioksStorage";
import auth from '@/api/auth'
// import createPersistedState from "vuex-persistedstate"
Vue.use(Vuex)

const systemConfig = 'SYSTEM_CONFIG'


function hasPermission(roles, route) {
  if (route.meta && route.meta.roles) {
    return roles.some(role => route.meta.roles.includes(role))
  } else {
    return true
  }
}
function filterAsyncRoutes(routes, roles) {
  const res = []
  routes.forEach(route => {
    const tmp = { ...route }
    if (hasPermission(roles, tmp)) {
      if (tmp.children) {
        tmp.children = filterAsyncRoutes(tmp.children, roles)
      }
      res.push(tmp)
    }
  })
  return res
}

// 创建实例
// const vuexPersisted = new VuexPersistence({
// 	storage: window.localStorage,
//   render:state=>({
//   	...state
//   })
// });

// const handleStore = store => {
//   let localStorage = window.localStorage
//   console.log('localStorage.store', localStorage.store)
//   if (localStorage.store) {
//     store.replaceState(JSON.parse(localStorage.store))
//   }
//   store.subscribe((mutation, state) => {
//     let oldState = JSON.parse(localStorage.getItem('store'))
//     let store = oldState && oldState !== '' ? Object.assign(oldState, state) : state
//     localStorage.setItem('store', JSON.stringify(store))
//   })
// }

export default new Vuex.Store({
  state: {
    userInfo: {},
    renewYouthNum:0,
    roles: '',
    routes: [],
    token: '',
    addRoutes: [],
    heartTimer: null,
    repeatLogin: {
      flag: false,
      msg: ""
    },
  },
  mutations: {
    setRepeatLogin(state, obj) {
      state.repeatLogin = obj;
    },
    setUserInfo(state) {
      let info = storage.get('userInfo')
      if (info) {
        state.userInfo = info
      }
    },
    setRoles(state, roles) {
      state.roles = roles
    },
    setToken(state, token) {
      state.token = token
    },
    setRenewYouthNum(state) {
      let youthNum = storage.get('renewYouthNum');
      if(youthNum){
        state.renewYouthNum = storage.get('renewYouthNum');
      }else{
        state.renewYouthNum = 0;
      }
    },
    updataInfo(state, info) {
      let userInfo = storage.get('userInfo')
      storage.set('userInfo', { ...userInfo, ...info })
      state.userInfo = { ...userInfo, ...info }
    },
    SET_ROUTES: (state, routes) => {
      state.addRoutes = routes
      state.routes = constantRoutes.concat(routes)
    },
    setHeartBeat(state, params) {
      if (state.heartTimer) clearInterval(state.heartTimer)
      state.heartTimer = setInterval(() => {
        beat().then(res => {
          // console.log('heart', res)
        }).catch(err => {
          console.error('err', err)
        })
      }, 60000)
      storage.set('heartTimer', state.heartTimer)
    },
    clearHeart(state, params) {
      clearInterval(state.heartTimer)
      storage.remove('heartTimer')
    }
  },
  actions: {
    getInfo({ commit }) {
      return new Promise(resolve => {
        let userRole = storage.get('userInfo').userRole
        commit('setRoles', userRole)
        resolve(userRole)
      })
    },
    generateRoutes({ commit }, roles) {
      return new Promise(resolve => {
        let accessedRoutes
        if (roles.includes('admin')) {
          accessedRoutes = asyncRoutes || []
        } else {
          accessedRoutes = filterAsyncRoutes(asyncRoutes, roles)
        }
        commit('SET_ROUTES', accessedRoutes)
        resolve(accessedRoutes)
      })
    }
  },
  getters: {
    roles: state => state.roles,
    token: state => state.token,
    sysFootContent: (state) => {
      // return state.appConfig.systemConfig.sysFootContent || yioksStorage.getItem(systemConfig).sysFootContent || ''
      if(state.appConfig.systemConfig && state.appConfig.systemConfig.sysFootContent) {
        return state.appConfig.systemConfig.sysFootContent
      } else {
        return  yioksStorage.getItem(systemConfig) ? yioksStorage.getItem(systemConfig).sysFootContent : ''
      }
    },

    sysPlatformName: (state) => {
      // return state.appConfig.systemConfig.sysPlatformName || yioksStorage.getItem(systemConfig).sysPlatformName || ''
      if(state.appConfig.systemConfig && state.appConfig.systemConfig.sysPlatformName) {
        return state.appConfig.systemConfig.sysPlatformName
      } else {
        return  yioksStorage.getItem(systemConfig) ? yioksStorage.getItem(systemConfig).sysPlatformName : ''
      }
    },

    sysPlatformTelephone: (state) => {
      // return state.appConfig.systemConfig.sysPlatformTelephone || yioksStorage.getItem(systemConfig).sysPlatformTelephone || ''
      if(state.appConfig.systemConfig && state.appConfig.systemConfig.sysPlatformTelephone) {
        return state.appConfig.systemConfig.sysPlatformTelephone
      } else {
        return  yioksStorage.getItem(systemConfig) ? yioksStorage.getItem(systemConfig).sysPlatformTelephone : ''
      }
    },

    sysHomeBackground: (state) => {
      if(state.appConfig.systemConfig && state.appConfig.systemConfig.sysHomeBackground) {
        return state.appConfig.systemConfig.sysHomeBackground
      } else {
        return  yioksStorage.getItem(systemConfig) ? yioksStorage.getItem(systemConfig).sysHomeBackground : ''
      }
    },
    sysLoginBackground: (state) => {
      // return state.appConfig.systemConfig.sysLoginBackground || yioksStorage.getItem(systemConfig).sysLoginBackground || ''
      if(state.appConfig.systemConfig && state.appConfig.systemConfig.sysLoginBackground) {
        return state.appConfig.systemConfig.sysLoginBackground
      } else {
        return  yioksStorage.getItem(systemConfig) ? yioksStorage.getItem(systemConfig).sysLoginBackground : ''
      }
    },

    sysTitleImage: (state) => {
      // return state.appConfig.systemConfig.sysTitleImage || yioksStorage.getItem(systemConfig).sysTitleImage || ''
      if(state.appConfig.systemConfig && state.appConfig.systemConfig.sysTitleImage) {
        return state.appConfig.systemConfig.sysTitleImage
      } else {
        return  yioksStorage.getItem(systemConfig) ? yioksStorage.getItem(systemConfig).sysTitleImage : ''
      }
    },
    sysHostType: (state) => {
      // return state.appConfig.systemConfig.sysHostType || yioksStorage.getItem(systemConfig).sysHostType || ''
      if(state.appConfig.systemConfig && state.appConfig.systemConfig.sysHostType) {
        return state.appConfig.systemConfig.sysHostType
      } else {
        return  yioksStorage.getItem(systemConfig) ? yioksStorage.getItem(systemConfig).sysHostType : ''
      }
    },
    sysLogo: (state) => {
      // return state.appConfig.systemConfig.sysLogo || yioksStorage.getItem(systemConfig).sysLogo || ''
      if(state.appConfig.systemConfig && state.appConfig.systemConfig.sysLogo) {
        return state.appConfig.systemConfig.sysLogo
      } else {
        return  yioksStorage.getItem(systemConfig) ? yioksStorage.getItem(systemConfig).sysLogo : ''
      }
    },
    sysPlatformCSQrcode: (state) => {
      // return state.appConfig.systemConfig.sysPlatformCSQrcode || yioksStorage.getItem(systemConfig).sysPlatformCSQrcode || ''
      if(state.appConfig.systemConfig && state.appConfig.systemConfig.sysPlatformCSQrcode) {
        return state.appConfig.systemConfig.sysPlatformCSQrcode
      } else {
        return  yioksStorage.getItem(systemConfig) ? yioksStorage.getItem(systemConfig).sysPlatformCSQrcode : ''
      }
    },
    sysRegister: (state) => {
      // return state.appConfig.systemConfig.sysRegister || yioksStorage.getItem(systemConfig).sysRegister || ''
      if(state.appConfig.systemConfig && state.appConfig.systemConfig.sysRegister) {
        return state.appConfig.systemConfig.sysRegister
      } else {
        return  yioksStorage.getItem(systemConfig) ? yioksStorage.getItem(systemConfig).sysRegister : ''
      }
    },

  },

  modules: {
    appConfig: configStore,
  },
  // plugins: [createPersistedState()]
  // plugins: [handleStore]
})
